import { OrderPdfData, PatientData, ClinicInfo, FormResponse } from '../models/order-pdf.model';

export class OrderPdfMapper {
  
  static mapScanToOrderPdf(scan: any, formResponses?: any[]): OrderPdfData {
    const result = {
      orderId: scan.ID || scan.id,
      identifier: scan.identifier,
      createdAt: scan.createdAt || scan.date || new Date(),
      patientData: this.extractPatientData(scan),
      deviceInfo: scan.data?.['Device Info'] || scan.deviceInfo,
      clinic: this.extractClinicInfo(scan),
      formResponses: formResponses || this.extractFormResponses(scan)
    };
    
    return result;
  }

  private static extractPatientData(scan: any): PatientData {
    const patientData = scan.data?.['Patient Data'] || scan.patientData || scan.data || {};
    
    return {
      name: patientData.name || '',
      surname: patientData.surname || '',
      second_surname: patientData.second_surname || patientData.secondSurname || '',
      birthDate: patientData.birthDate || patientData.birth_date,
      email: patientData.email || '',
      sex: patientData.sex || patientData.gender,
      shoeSize: patientData.shoeSize || patientData.shoe_size,
      weight: patientData.weight,
      ...this.extractAdditionalPatientFields(patientData)
    };
  }

  private static extractAdditionalPatientFields(patientData: any): Record<string, any> {
    const baseFields = [
      'name', 'surname', 'second_surname', 'secondSurname',
      'birthDate', 'birth_date', 'email', 'sex', 'gender',
      'shoeSize', 'shoe_size', 'weight', 'clinic'
    ];
    
    const additionalFields: Record<string, any> = {};
    
    Object.keys(patientData).forEach(key => {
      if (!baseFields.includes(key) && patientData[key] !== undefined && patientData[key] !== null) {
        additionalFields[key] = patientData[key];
      }
    });
    
    return additionalFields;
  }

  private static extractClinicInfo(scan: any): ClinicInfo | undefined {
    const clinic = scan.data?.['Patient Data']?.clinic || scan.clinic;
    
    if (!clinic) return undefined;
    
    return {
      ID: clinic.ID || clinic.id,
      name: clinic.name || '',
      clientID: clinic.clientID || clinic.client_id,
      ...clinic
    };
  }

  private static extractFormResponses(scan: any): FormResponse[] | undefined {
    // Si ya vienen como array separado
    if (scan.formResponses && Array.isArray(scan.formResponses)) {
      return scan.formResponses;
    }
    
    // Si viene dentro de data
    if (scan.data?.formResponses && Array.isArray(scan.data.formResponses)) {
      return scan.data.formResponses;
    }
    
    return undefined;
  }

  static mapFormResponseToOrderPdf(
    formResponse: any,
    orderId: string,
    patientData?: PatientData,
    clinic?: ClinicInfo
  ): OrderPdfData {
    return {
      orderId: orderId,
      identifier: formResponse.identifier,
      patientData: patientData || {
        name: '',
        surname: ''
      },
      clinic: clinic,
      formResponses: [formResponse]
    };
  }

  static validateOrderPdfData(data: OrderPdfData): { valid: boolean; errors: string[] } {
    const errors: string[] = [];
    
    if (!data.orderId) {
      errors.push('Order ID is required');
    }
    
    if (!data.patientData) {
      errors.push('Patient data is required');
    } else {
      if (!data.patientData.name) {
        errors.push('Patient name is required');
      }
      if (!data.patientData.surname) {
        errors.push('Patient surname is required');
      }
    }
    
    return {
      valid: errors.length === 0,
      errors
    };
  }
}
